import MagneticTravelRtPanel from "./MagneticTravelRtPanel";

/** MDS：布局同 RS，磁轴设备可展示行程面板（容园机械轴无额外面板）。 */
const Mds = (props: any) => {
  const { checkData, getAfterChangeData, isMagnetic = false } = props;
  if (!isMagnetic) return null;
  return (
    <MagneticTravelRtPanel
      checkData={checkData}
      getAfterChangeData={getAfterChangeData}
      showRt={false}
    />
  );
};

export default Mds;
